const initialState = {}

const buildReconciliation = (state, params) => {
  const { game, player_reservations } = params
  const revenue = _.sumBy(player_reservations, o => parseFloat(o.cost_of_player))
  const received = _.sumBy(player_reservations, o => parseFloat(o.paid_amount))
  const facilityCost = parseFloat(game.facility_cost)
  const reconciliationData = {
    event_name: game.displayed_name,
    event_time: game.date_time,
    revenue: revenue,
    received: received,
    unpaid: revenue - received,
    facility_commission: facilityCost,
    plei_net: received - facilityCost
  }
  const index = state.reconciliations.findIndex(r => r.id == game.id)
  return {...state.reconciliations[index], ...reconciliationData}
}

const updatedReconciliations = (state, params) => {
  const index = state.reconciliations.findIndex(r => r.id == params.id)
  if (index == -1) return state.reconciliations

  return [
    ...state.reconciliations.slice(0, index), 
    params,
    ...state.reconciliations.slice(index + 1, state.reconciliations.length)
  ]
}

const updateLocations = (state, params) => {
  return state.reconciliations.map(r => r.location_id == params.location_id ? {...r, ...params} : r)
}

const updateFacilityPay = (state, params) => {
  const index = state.reconciliations.findIndex(r => r.id == params.game_id)
  if (index == -1) return state.reconciliations

  const data = {
    facility_pay_id: params.id,
    how_paid: params.payment_type,
    plei_paid: params.paid_amount,
    when_paid: params.paid_at,
    notes: params.notes,
    captain_paid: params.captain_paid_amount,
    captain_how_paid: params.captain_payment_type,
    captain_when_paid: params.captain_paid_at,
    captain_notes: params.captain_notes
  }

  return [
    ...state.reconciliations.slice(0, index), 
    {...state.reconciliations[index], ...data},
    ...state.reconciliations.slice(index + 1, state.reconciliations.length)
  ]
}

const releasedReconciliations = (state, id) => {
  const index = state.reconciliations.findIndex(r => r.id == id)
  if (index == -1) return state.reconciliations

  return [
    ...state.reconciliations.slice(0, index), 
    ...state.reconciliations.slice(index + 1, state.reconciliations.length)
  ]
}

const reconciliations = (state = initialState, {type, payload}) => {
  switch (type) {
    case 'RECONCILIATIONS.INIT':
      return {...state, ...payload, loading: false, changedGame: null, filters: []}
    case 'RECONCILIATIONS.LOADING':
      return {...state, loading: true}
    case 'RECONCILIATIONS.RECEIVED':
      return {...state, ...payload, loading: false }
    case 'RECONCILIATIONS.GAME_CHANGED':
      return {...state, changedGame: payload }
    case 'RECONCILIATIONS.UPDATE_GAME':
      const data = buildReconciliation(state, payload)
      return {...state, reconciliations: updatedReconciliations(state, data) }
    case 'RECONCILIATIONS.UPDATE':
      return {...state, reconciliations: updatedReconciliations(state, payload), changedGame: null }
    case 'RECONCILIATIONS.UPDATE_LOCATION':
      const locationData = {location_id: payload.id, payment_type: payload.payment_type}
      return {...state, reconciliations: updateLocations(state, locationData)}
    case 'RECONCILIATIONS.REMOVE':
      return {...state, reconciliations: releasedReconciliations(state, payload), changedGame: null }
    case 'RECONCILIATIONS.UPDATE_FACILITY_PAY':
      return {...state, reconciliations: updateFacilityPay(state, payload) }
    case 'RECONCILIATIONS.APPLY_FILTERS':
      return {...state, filters: payload }
    default:
      return state
  }
}

export default reconciliations
